import { useSelector } from 'react-redux'

const useLoan = loanId => {
  return useSelector(state => state.loans.byId[loanId])
}
export default useLoan
